/* eslint-disable fp/no-mutation */
/* eslint-disable fp/no-mutating-methods */
import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useLocation} from 'react-router-dom';
import Stack from '@mui/material/Stack';
import useMediaQuery from '@mui/material/useMediaQuery';
import LoginOutlinedIcon from '@tenancy.nz/icons/LoginOutlined';
import {LogoutButton} from '@tenancy.nz/ui';
import Hamburger from '../../components/Hamburger';
import LinkButton from '../../components/LinkButton';
import useLogoutMutation from '../../hooks/useLogoutMutation';
import {setOpen} from './slice';
import {userState} from '../user/userSlice';
import * as consts from '../../utils/constants';
import {getCookie} from '../../utils/helpers';

function HeaderNavFeature() {
  const dispatch = useDispatch();
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('md'));
  const {pathname} = useLocation();
  const {token} = useSelector(userState);
  const {open} = useSelector(state => state.navigation);

  const [handleLogout] = useLogoutMutation();

  const isLoggedIn = !!getCookie(consts.KEY_AUTHENTICATION_TOKEN) || !!token;

  React.useEffect(() => {
    if (isMobile && open) dispatch(setOpen(false));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  React.useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  const handleToggleNav = () => {
    dispatch(setOpen(!open));
  };

  return (
    <Stack direction="row" alignItems="center" gap={4}>
      {!isMobile && !isLoggedIn && (
        <LinkButton
          to={consts.SLUG_LOGIN}
          variant="outlined"
          startIcon={<LoginOutlinedIcon />}>
          Log in
        </LinkButton>
      )}
      {!isMobile && isLoggedIn && (
        <LogoutButton variant="link" onClick={() => handleLogout()} />
      )}
      {isMobile && isLoggedIn && (
        <Hamburger active={open} onClick={handleToggleNav} />
      )}
    </Stack>
  );
}

export default HeaderNavFeature;
